const dateFormatter = new Intl.DateTimeFormat('es-DO', {
  dateStyle: 'medium',
  timeStyle: 'short',
})

const numberFormatter = new Intl.NumberFormat('es-DO')

export function formatDate(value: unknown) {
  if (typeof value !== 'string' || !value) return '—'
  const date = new Date(value)
  return Number.isNaN(date.getTime()) ? value : dateFormatter.format(date)
}

export function formatNumber(value: unknown) {
  return typeof value === 'number' ? numberFormatter.format(value) : '0'
}

export function humanize(value: unknown) {
  if (value === null || value === undefined || value === '') return '—'
  if (typeof value === 'boolean') return value ? 'Sí' : 'No'
  if (typeof value === 'number') return formatNumber(value)
  if (typeof value === 'string') return value.split('_').join(' ')
  return JSON.stringify(value)
}

export function shortID(value: unknown) {
  if (typeof value !== 'string') return '—'
  return value.length > 16 ? `${value.slice(0, 8)}…${value.slice(-5)}` : value
}

export function initials(value: string | undefined) {
  if (!value) return 'BD'
  return value
    .split(/\s+/)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase() ?? '')
    .join('')
}

export function errorMessage(error: unknown) {
  return error instanceof Error ? error.message : 'Ocurrió un error inesperado.'
}
